module.exports = function() {
  return new Worker(__webpack_public_path__ + "0385ff5a8211868b92ca.worker.js");
};